module.exports = __webpack_public_path__ + "img/mc-off.bc022d25.gif";